<template>
    <span>
        <label :for="autoId" :class="['control-label', labelCol, labelClass]">
            <slot name="label">{{ label }}</slot>
        </label>
        <div :class="controlCol">
            <slot :id="autoId" />
        </div>
    </span>
</template>

<script>
'use strict';

let uuid = 0;
export default {
    // eslint-disable-next-line vue/require-prop-types
    props: ['labelCol', 'controlCol', 'labelClass', 'label', 'id'],
    data() {
        return {
            //doesn't work
            autoId: this.id || ('component-uuid-' + String(uuid++)),
        };
    },
};
</script>
